module.exports = __webpack_public_path__ + "assets/img/35_1119.934fb232.jpg";